<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-text>
            <upload-file
              :clearQueue="fileClear"
              @cleared="onQueueCleared"
              :initialFilePath="file.file_path"
              @update-saved-file-path="updateSavedFilePath"
            ></upload-file>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <paginated-table
          :data="files"
          :columns="tableColumns"
          :title="$t('title.admin_archive')"
          @updatePagination="updatePagination"
        >
        </paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UploadFile from "@/components/Forms/UploadFile.vue";
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import { getArchiveColumnsColumns } from "@/views/AdminView/columns";
import { deletePopup, success } from "@/views/AdminView/popups";

import { archiveApi, fileApi } from "@/api/api";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

export default {
  components: {
    UploadFile,
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      fileClear: false,
      category: "ADMIN",
      file: {
        idx: null,
        title: null,
        image_name: null,
        down_file_name: null,
        file_name: null,
        category: "A",
        file_path: "",
      },
      files: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 0,
          total_pages: 1,
        },
        elements: [],
      },
      tableColumns: getArchiveColumnsColumns({
        download: this.handleDownload,
        delete: this.handleDelete,
      }),
    };
  },
  methods: {
    async updateSavedFilePath(newPath) {
      this.isLoading = true;
      // 파일명 추출
      let cleanedName = "";
      const match = newPath.match(/\/([^/]+)\.\w+$/);
      if (match) {
        const fullName = match[1]; // 확장자를 제외한 파일 이름 전체
        cleanedName = fullName.replace(/(_\d{4,})+$/, ""); // 마지막 숫자 제거
      } else {
        return;
      }

      this.file.title = cleanedName;
      this.file.down_file_name = cleanedName;
      this.file.file_path = newPath;

      await this.createArchive();
      await this.fetchArchivesByCategory();

      this.fileClear = true;
      await this.initFile();
      this.isLoading = false;
    },
    onQueueCleared() {
      this.fileClear = false;
    },
    updatePagination(pagination) {
      this.files.page_info.size = pagination.size;
      this.files.page_info.page = pagination.page;

      this.fetchArchivesByCategory();
    },
    handleDownload(archive) {
      this.downloadFile(archive);
    },
    async handleDelete(archive) {
      const isConfirmed = await deletePopup(archive);

      if (!isConfirmed) {
        return;
      }

      const isDeleted = await this.deleteArchive(archive);

      if (isDeleted) {
        await success();
        this.fetchArchivesByCategory();
      }
    },

    initFile() {
      this.file = {
        idx: null,
        title: null,
        image_name: null,
        down_file_name: null,
        file_name: null,
        category: "A",
        file_path: "",
      };
    },

    async downloadFile(archive) {
      try {
        this.isLoading = true;

        const params = {
          file_name: archive.file_path.split("/").pop(),
        };

        const response = await fileApi.fileDownload(params);

        if (response && response.status === 200) {
          const mimeType = response.headers["content-type"];
          const blob = new Blob([response.data], { type: mimeType });
          const fileURL = URL.createObjectURL(blob);

          // 자동 열기
          if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", archive.down_file_name); // 다운로드 파일 이름 설정
            link.setAttribute("target", "_blank"); // 새 창에서 열기
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          } else {
            // 다운로드로 처리
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", archive.down_file_name); // 다운로드 파일 이름 설정
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        }
      } catch (error) {
        alert("파일 다운로드에 실패했습니다. 잠시후 다시 시도해주세요.");
      } finally {
        this.isLoading = false;
      }
    },

    async createArchive() {
      try {
        this.isLoading = true;
        const response = await archiveApi.createArchive(this.file);
        if (response && response.status === 201) {
          return true;
        }
        return false;
      } catch {
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    async fetchArchivesByCategory() {
      try {
        this.isLoading = true;
        const params = {
          category: this.category,
          page: this.files.page_info.page,
          size: this.files.page_info.size,
        };
        const response = await archiveApi.showAllByCateogory(params);
        if (response && response.status === 200) {
          this.files = response.data.response;
          return true;
        }
        return false;
      } catch {
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    async deleteArchive(archive) {
      try {
        this.isLoading = true;
        const response = await archiveApi.deleteArchive(archive);
        if (response && response.status === 204) {
          return true;
        }
        return false;
      } catch {
        return false;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetchArchivesByCategory();
  },
};
</script>

<style scoped></style>
